import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BackBar from "../home/BackBar";
import ListView from "../home/component/ListView";
// import MapView from "../home/component/MapView";
import Footer from "../../common/Footer";
import Header from "../../common/HeaderAfterLogin";
import { useTranslation } from "react-i18next";
import { lang } from "../../lang";
// import RecommendedBox from '../home/component/RecommendedProfile'

const RecommendedProfile = () => {
  const [ln,setLn] = useState('en')
  const [mapView, setMapView] = useState(true);
  const [listView, setListView] = useState(true);
  const [locationTitle, setLocationTitle] = useState()
  const location = useLocation()

const getTitle = ()=>{
  setLocationTitle(location?.state?.title)
}
useEffect(() => {
  if(localStorage.getItem("language") != null){
  setLn(localStorage.getItem("language"))
}
})


  const title = location?.state?.title
  console.log('title', title)

  useEffect(()=>{
    getTitle()
  },[])
  
  const {t} = useTranslation()
  return (
    <>
    <Header/>
      <div className="wrapped-content-area pt-3">
        {/* <BackBar title="Candidate Near Me" /> */}
        
        <BackBar title={lang && Object.keys(lang).length > 0 ? lang[ln]?.Home[location?.state?.title]:""} />


        {/* <h2 className="heading mx-4 useMyLocation-box">
          <img
            src="./images/location-indicater.png"
            alt=""
            className="mr-2"
          />
          <span className="location-main-text">Use my Current Location</span>
        </h2> */}

        <div className=" space-between d-flex mb-2 sticky-top bg-theme" style={{paddingTop:'20px'}}>
          <div className="d-flex ">
            <button
              onClick={() => {
                setMapView(true);
                setListView(false);
              }}
              className={mapView ? "login-active" : "login"}
            >
              {t('Map View')}
            </button>
            <button
              onClick={() => {
                setMapView(false);
                setListView(true);
              }}
              className={mapView ? "login" : "login-active"}
            >
              {t('List View')}
            </button>
          </div>
        </div>
        <div className="mt-3">
          <div className="row">
            {/* <RecommendedBox /> */}
             <ListView map = {mapView}/>
          </div>
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default RecommendedProfile;
